<script setup lang="ts">
import type { HouseDetails } from '~/types/house/types'

const { trackEvent } = useTracking()

const props = defineProps<{
  house: HouseDetails
  houseDestinations: HouseDetails['destination']
  modelValue: boolean
}>()
defineEmits<{
  'update:model-value': [value: boolean]
}>()

const firstPicture = computed(() => props.house?.firstPhoto?.url || '')

const tracking = (label: string) => {
  trackEvent({
    event: 'product_page_shared',
    label,
    product: {
      ...buildTrackEventProduct({
        houseId: props.house.id,
        houseName: props.house.name,
        iconic: props.house.iconicCollection,
        onlineBookingAvailable: props.house.onlineReservation,
      }),
    },
  })
}
</script>

<template>
  <BaseModalV2
    :model-value="modelValue"
    size="xs"
    has-close-button
    :mobile-full-height="false"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template #content>
      <div>
        <div class="mb-8 font-bold">
          {{ $t('house.share.sharePosting') }}
        </div>
        <h2 class="text-4xl leading-none">
          {{ house.name }}
        </h2>
        <HouseDestinationBreadcrumb :house-destinations="houseDestinations" />
        <div class="mb-2.5 flex justify-between text-md text-gray-600">
          <span>
            {{ house.capacity }}
            {{ $t('house.capacityKey', house.capacity) }}</span
          >
          <span>·</span>
          <span>
            {{ house.bedrooms }}
            {{ $t('house.bedroomsKey', house.bedrooms) }}</span
          >
          <span>·</span>
          <span>
            {{ house.bathrooms }}
            {{ $t('house.bathroomsKey', house.bathrooms) }}</span
          >
          <template v-if="house.surface">
            <span>·</span>
            <span>{{ house.surface }} {{ $t('house.surface') }}</span>
          </template>
        </div>
        <BaseNuxtImg
          class="mb-6 sm:mb-9"
          :alt="house.name"
          :src="firstPicture"
          width="400"
          height="265"
        />
        <BaseShare @tracking="tracking" />
      </div>
    </template>
  </BaseModalV2>
</template>
